import { render, staticRenderFns } from "./PageAdUpdate.vue?vue&type=template&id=d39da808"
import script from "./PageAdUpdate.vue?vue&type=script&lang=ts"
export * from "./PageAdUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports